import React, { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";

import { CustomTextFieldProps } from "./CustomTextField.Props";
import { NumericFormat } from "react-number-format";

const CustomTextField: React.FC<CustomTextFieldProps> = ({
	name,
	label,
	type = "text",
	variant = "outlined",
	required = false,
	className,
	isDisabled = false,
	rows = undefined,
	startAdornment,
	endAdornment,
	applyCurrencyFormat = false,
	prefix = "R ",
	hasFocus = false,
	allowNegative = false,
	maxLengthLimit = undefined,
	handleChange,
	handleInputChange,
}) => {
	const methods = useFormContext();
	const [previousValue, setPreviousValue] = useState<string>("");

	return (
		<Controller
			name={name}
			control={methods.control}
			render={({ field: { onChange, value, ref }, fieldState: { error } }) =>
				!applyCurrencyFormat ? (
					<TextField
						required={required}
						type={type}
						variant={variant}
						onChange={onChange}
						value={value || ""}
						label={label}
						error={!!error}
						inputRef={ref}
						helperText={error ? error.message : null}
						className={className}
						disabled={!!isDisabled}
						rows={rows}
						multiline={!!rows}
						autoComplete="off"
						onBlur={(event) => {
							onChange(event.target.value.trim());
							if (
								handleInputChange &&
								(hasFocus ? previousValue !== event.target.value.trim() : true)
							) {
								handleInputChange(event.target.value.trim());
							}
							setPreviousValue("");
						}}
						onFocus={(event) => {
							if (hasFocus) {
								setPreviousValue(event.target.value);
							}
						}}
						InputProps={{
							startAdornment: startAdornment,
							endAdornment: endAdornment,
							inputProps: { maxLength: maxLengthLimit },
						}}
					/>
				) : (
					<NumericFormat
						customInput={TextField}
						variant={variant}
						label={label}
						error={!!error}
						inputRef={ref}
						helperText={error ? error.message : null}
						thousandSeparator=","
						decimalSeparator="."
						// allowedDecimalSeparators={[",", "."]}
						prefix={prefix}
						decimalScale={2}
						fixedDecimalScale={true}
						required={required}
						value={value || ""}
						className={className}
						disabled={!!isDisabled}
						autoComplete="off"
						allowNegative={allowNegative}
						onValueChange={(values) => {
							onChange(values.floatValue);
							if (handleChange) handleChange(values.floatValue);
						}}
						InputProps={{
							startAdornment: startAdornment,
							endAdornment: endAdornment,
						}}
					/>
				)
			}
		/>
	);
};

export default CustomTextField;
